import { useIntl } from 'react-intl';

import { PrizeDumb } from '@sorare/core/src/components/landing/PrizesBlock/PrizeDumb';
import { messages } from '@sorare/core/src/components/landing/PrizesBlock/messages';

import personalizedVideoImage from './assets/personalizedVideoImage.jpg';

type Props = {
  isHovered?: boolean;
};

export const PersonalizedVideo = ({ isHovered }: Props) => {
  const { formatMessage } = useIntl();

  return (
    <PrizeDumb
      title={formatMessage({
        id: 'Landing.Prizes.nba.video',
        defaultMessage: 'Personalized Videos from NBA Stars',
      })}
      subtitle={formatMessage(messages.access)}
      cta={formatMessage(messages.watchCTA)}
      bgImage={personalizedVideoImage}
      isHovered={isHovered}
      comingSoon
    />
  );
};
